<script type="text/babel">
import axios from 'axios'
import CountrySelect from "./Form/CountrySelect.vue";

export default {
    data() {
        return {
            state: 'unsubmitted',
            emailConfirm: '',
            emailsDoNotMatch: false,
            form: {
                bike: {
                    frame_no: '',
                    model: '',
                },
                consumer: {
                    first_name: '',
                    last_name: '',
                    address: '',
                    address2: '',
                    birth_date: '',
                    email: '',
                    phone: '',
                    city: '',
                    state: '',
                    country: '',
                    postal_code: '',
                    contact_preference: '',
                    subscription: true
                },
                purchase_date: '',
            },
            errors: {}
        }
    },
    mounted() {
    },
    props: ['csrfToken', 'csrfTokenName'],
    components: {
        CountrySelect
    },
    computed: {
        unsubmitted() {
            return this.state == 'unsubmitted'
        },
        sending() {
            return this.state == 'sending'
        },
        sent() {
            return this.state == 'sent'
        },
        emailValid() {
            return (!this.form.consumer.email.length || (this.form.consumer.email.length && this.form.consumer.email == this.emailConfirm)) ? true : false
        },
        api() {
            return axios.create({})
        },
    },
    methods: {
        submit() {
            this.form[this.csrfTokenName] = this.csrfToken;
            this.emailsDoNotMatch = false

            if (this.emailValid)
            {
                this.state = 'sending'
                this.api.post('/api/registration', this.form).then((response) => {
                    if (response.data.statusCode === 200)
                    {
                        this.state = 'sent'
                    }
                    else
                    {
                        this.errors = response.data.body.error
                        this.state = 'unsubmitted'
                    }
                }, (error) => {
                })
            }
            else
            {
                this.emailsDoNotMatch = true
            }

        },
        hasError(field) {
            let data = false
            for (let key of Object.keys(this.errors))
            {
                if (field === key)
                {
                    data = true
                    break
                }
            }
            return data
        },
        countrySelected(val) {
            this.form.consumer.country = val;
        }
    }
}
</script>
